import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateAuditState from './audit';
import updateDatasetState from './dataset';
import updateRoleState from './role';
import updateCohortState from './cohort';
import updateCollectionState from './collection';
import updateSearchState from './search';
import updateUserGroupState from './usergroup';

const handlers = {
  ...updateAuditState,
  ...updateDatasetState,
  ...updateRoleState,
  ...updateCohortState,
  ...updateCollectionState,
  ...updateSearchState,
  ...updateUserGroupState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
